import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Availability_Status_Enum } from '@kheops/graphql';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import FilterDisplay, { FilterDisplayMode } from '../../search/filters/FilterDisplay';

export type AvailabilityFilterValues = Availability_Status_Enum | 'ALL';

interface ProductAvailabilityFilterProps {
  availabilityFilter: AvailabilityFilterValues;
  onChange: (availabilityValue: AvailabilityFilterValues) => void;
  mode?: FilterDisplayMode;
}

export default function ProductAvailabilityFilter({ availabilityFilter, onChange, mode = 'POPOVER' }: ProductAvailabilityFilterProps): React.JSX.Element {
  const { t } = useTranslation(['products', 'common']);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChange((event.target as HTMLInputElement).value as AvailabilityFilterValues);
  };

  const filterContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <RadioGroup
        name="availability-controlled-radio-buttons-group"
        value={availabilityFilter}
        onChange={handleChange}
      >
        <FormControlLabel value="ALL" control={<Radio />} label={t('common:all_products')} />
        <FormControlLabel value={Availability_Status_Enum.Available} control={<Radio />} label={t('products:available_products')} />
        <FormControlLabel value={Availability_Status_Enum.Unavailable} control={<Radio />} label={t('products:unavailable_products')} />
      </RadioGroup>
    </Box>
  );

  return (
    <FilterDisplay
      mode={mode}
      name="availabilityFilter"
      activeItemCount={availabilityFilter === 'ALL' ? 0 : 1}
      icon={<RemoveRedEyeOutlinedIcon />}
      label={t('products:availability')}
      content={filterContent}
    />
  );
}
